import React from 'react';
import PropTypes from 'prop-types';
import './View.css';

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
      color: 'light',
    };
    this.previousScrollPos = 0;
    this.colorMode = props.colorMode;
  }

  componentDidMount() {
    this.handler = this.handleScroll.bind(this);
    this.scrollListener = window.addEventListener('scroll', this.handler);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handler);
  }

  handleScroll() {
    let colors = [];
    if (this.colorMode === '1') {
      colors = ['light', 'light-dark', 'white', 'light', 'dark'];
    } else if (this.colorMode === '2') {
      colors = ['light', 'light-dark', 'light', 'dark'];
    } else if (this.colorMode === '3') {
      colors = ['white', 'light', 'dark'];
    } else if (this.colorMode === '4') {
      colors = ['light-dark', 'light', 'dark'];
    }
    const topMenuHeight = 0;
    const scrolledHeight = (document.body.scrollTop || document.documentElement.scrollTop) - topMenuHeight;
    if (this.previousScrollPos !== 0 && Math.abs(scrolledHeight - this.previousScrollPos) < 20) {
      return;
    }
    const views = Array.from(document.getElementById('global_view').children);
    const viewHeights = [];
    views.forEach((view) => {
      viewHeights.push(view.clientHeight);
    });
    let viewHeight = 0;
    const viewportHeight = (window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0]) * 1.20;
    const stepSizeHeightUp = viewportHeight * (1 / 3);
    const stepSizeHeightDown = viewportHeight * (1 / 3);
    const stepSizeHeightStatic = stepSizeHeightUp;
    let nextColor = '';
    for (let i = 0; i < viewHeights.length; i += 1) {
      viewHeight += viewHeights[i];
      if (scrolledHeight > this.previousScrollPos && scrolledHeight < viewHeight && viewHeight - scrolledHeight < stepSizeHeightDown) {
        nextColor = colors[(i + 1) % colors.length];
        break;
      } else if (scrolledHeight < this.previousScrollPos && scrolledHeight < viewHeight && viewHeight - scrolledHeight > stepSizeHeightUp) {
        nextColor = colors[(i) % colors.length];
        break;
      } else if (scrolledHeight < viewHeight - stepSizeHeightStatic) {
        nextColor = colors[(i) % colors.length];
        break;
      }
    }
    this.setState({ color: nextColor });
    this.previousScrollPos = scrolledHeight;
  }

  render() {
    const { children, color } = this.state;
    let viewClass = 'view';
    if (color === 'light') {
      viewClass += ' background_light';
    } else if (color === 'dark') {
      viewClass += ' background_dark';
    } else if (color === 'light-dark') {
      viewClass += ' background_light_dark';
    }

    return (
      <div className={viewClass} id="global_view">
        {children}
      </div>
    );
  }
}

View.defaultProps = {
  children: null,
  colorMode: '1',
};

View.propTypes = {
  children: PropTypes.node,
  colorMode: PropTypes.string,
};

export default View;



// WEBPACK FOOTER //
// ./src/components/View/View.jsx